import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from 'react';
import MiniMap from '../MiniMap';
import styles from '../ReportCard.module.scss';

export const GeoField = ({ geo, mapKey, maps, onToggle }) => {
  useInterfaceLanguage();
  if (!geo) return null;
  return <div>
    <div className={styles.detailGeoRow}>
      <button className={styles.detailGeoBtn} onClick={() => window.open(`https://www.google.com/maps?q=${geo}`, '_blank')}>{tr(" Открыть на карте")}</button>
      <button className={styles.detailGeoBtn} onClick={() => onToggle(mapKey)}>{maps[mapKey] ? tr(" Скрыть карту") : tr(" Мини-карта")}</button>
    </div>
    {tr(maps[mapKey] && <div className={styles.detailMapWrap}><MiniMap geo={geo} /></div>)}
  </div>;
};

export const InfoItem = ({ label, value, wide }) => { useInterfaceLanguage(); return (<div className={styles.detailInfoItem} style={wide ? { gridColumn: '1 / -1' } : undefined}>
  <span className={styles.detailInfoLabel}>{tr(label)}</span>
  <div className={styles.detailInfoValue}>{tr(value)}</div>
</div>); };

export const PhoneLink = ({ phone }) => { useInterfaceLanguage(); return (!phone || phone === '-' ? <span>—</span> : <a href={`tel:${phone}`} className={styles.detailPhoneLink}> {tr(phone)}</a>); };
